export class NotInitializedException extends Error {
  constructor() {
    super();
  }
}
